<template>
  <div class="service-door-code-lifetime">
    <div class="service-door-code-lifetime__row">
      <v-checkbox
        :input-value="localEnabled"
        :true-value="true"
        :false-value="false"
        label="Обновлять код"
        hide-details
        dense
        color="primary"
        class="service-door-code-lifetime__checkbox mt-0 pt-0"
        @change="onEnabledChange"
      />
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :disabled="!localEnabled"
        offset-y
        min-width="290"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="dateLabel"
            label="Дата обновления"
            outlined
            dense
            readonly
            clearable
            hide-details
            prepend-inner-icon="mdi-calendar"
            class="service-door-code-lifetime__date"
            :disabled="!localEnabled"
            v-bind="attrs"
            v-on="localEnabled ? on : {}"
            @click:clear="clearDate"
          />
        </template>
        <v-date-picker
          :value="date || null"
          :min="minDate"
          :max="maxDate"
          no-title
          @input="onDateInput"
        />
      </v-menu>
    </div>
    <v-text-field
      v-if="!localEnabled"
      :value="localComment"
      label="Комментарий"
      placeholder="Например: Новый дом"
      hint="При выключении обновления комментарий обязателен"
      persistent-hint
      outlined
      dense
      maxlength="500"
      :error-messages="commentError ? [commentError] : []"
      class="service-door-code-lifetime__comment"
      @input="onCommentInput"
    />
    <p v-if="showSecurityNote" class="service-door-code-lifetime__note">
      Для безопасности сервисный код обновляется раз в 2–3 недели по вторникам в 05:00. Код будет обновлён, установится новый
    </p>
    <p v-else-if="!localEnabled" class="service-door-code-lifetime__note">
      Обновление кода отключено. Сервисный код меняться не будет
    </p>
    <p v-if="rotateAtLabel" class="service-door-code-lifetime__note">
      Следующее обновление: {{ rotateAtLabel }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ServiceDoorCodeLifetime',
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
    date: {
      type: String,
      default: '',
    },
    rotateAt: {
      type: String,
      default: null,
    },
    comment: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      menu: false,
      commentError: '',
      localEnabled: this.enabled,
      localComment: this.comment || '',
    };
  },
  watch: {
    enabled (value) {
      this.localEnabled = !!value;
    },
    comment (value) {
      const text = value == null ? '' : String(value);
      if (text !== this.localComment) {
        this.localComment = text;
      }
    },
  },
  computed: {
    dateEmpty () {
      return String(this.date ?? '').trim() === '';
    },
    showSecurityNote () {
      return this.localEnabled && this.dateEmpty;
    },
    minDate () {
      return this.formatIso(new Date());
    },
    maxDate () {
      const date = new Date();
      date.setDate(date.getDate() + 90);
      return this.formatIso(date);
    },
    dateLabel () {
      if (this.dateEmpty) {
        return '';
      }
      const parts = String(this.date).split('-');
      if (parts.length !== 3) {
        return this.date;
      }
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    },
    rotateAtLabel () {
      if (!this.localEnabled || !this.rotateAt) {
        return '';
      }
      const [date, time] = String(this.rotateAt).split(' ');
      const parts = date.split('-');
      if (parts.length !== 3) {
        return this.rotateAt;
      }
      const hours = (time || '').slice(0, 5);
      return `${parts[2]}.${parts[1]}.${parts[0]}${hours ? ` ${hours}` : ''}`;
    },
  },
  methods: {
    formatIso (date) {
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${date.getFullYear()}-${month}-${day}`;
    },
    onEnabledChange (value) {
      if (value && typeof value === 'object') {
        return;
      }
      const enabled = !(value === false || value === null || value === undefined || value === 0 || value === '0' || value === 'false');
      this.localEnabled = enabled;
      this.$emit('update:enabled', enabled);
      if (enabled) {
        this.commentError = '';
      } else {
        this.menu = false;
        this.$emit('update:date', '');
      }
    },
    onCommentInput (value) {
      const text = typeof value === 'string'
        ? value
        : (value && value.target && typeof value.target.value === 'string' ? value.target.value : '');
      this.localComment = text;
      this.commentError = '';
      this.$emit('update:comment', text);
    },
    validationError () {
      if (!this.localEnabled && String(this.localComment ?? '').trim() === '') {
        return 'При выключении обновления укажите комментарий. Например: Новый дом';
      }
      if (this.localEnabled && !this.dateEmpty && (this.date < this.minDate || this.date > this.maxDate)) {
        return 'Дата обновления — не дальше 90 дней';
      }
      return '';
    },
    snapshot () {
      const comment = String(this.localComment ?? '').trim();
      return {
        rotationLocked: !this.localEnabled,
        rotationComment: this.localEnabled ? '' : comment,
        lifetimeDays: this.lifetimeDays(),
      };
    },
    onDateInput (value) {
      this.$emit('update:date', value || '');
      this.menu = false;
    },
    clearDate () {
      this.$emit('update:date', '');
    },
    validate () {
      const error = this.validationError();
      this.commentError = !this.localEnabled ? error : '';
      return error === '';
    },
    lifetimeDays () {
      if (!this.localEnabled || this.dateEmpty) {
        return null;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selected = new Date(`${this.date}T00:00:00`);
      const diff = Math.round((selected.getTime() - today.getTime()) / 86400000);
      if (diff < 1) {
        return 1;
      }
      return diff;
    },
  },
};
</script>

<style lang="scss" scoped>
.service-door-code-lifetime {
  margin-top: 4px;
  margin-bottom: 8px;
}

.service-door-code-lifetime__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
}

.service-door-code-lifetime__checkbox {
  flex: 0 0 auto;
  margin-right: 0;
}

.service-door-code-lifetime__date {
  flex: 0 1 280px;
  max-width: 280px;
  min-width: 200px;
}

.service-door-code-lifetime__comment {
  max-width: 520px;
  margin-top: 8px;
}

.service-door-code-lifetime__note {
  margin: 8px 0 0;
  color: #546e7a;
  font-size: 0.8125rem;
  line-height: 1.35;
  max-width: 520px;
}
</style>
